import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo("Page Not Found | Serpens Technology", "The page you are looking for does not exist.", { noindex: true });
  return (
    <section className="flex min-h-[70vh] items-center justify-center px-6 py-24" data-testid="not-found-page">
      <div className="text-center">
        <p className="font-display text-7xl font-bold text-gradient">404</p>
        <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight">This page doesn't exist</h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground">
          The link may be old or mistyped. Head back home or explore our services.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="not-found-home" className="flex items-center gap-2 rounded-full bg-secondary px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-blue-800/25 transition-all duration-300 hover:-translate-y-0.5 active:scale-95">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
          <Link to="/services" data-testid="not-found-services" className="rounded-full border border-border px-6 py-3 text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground">
            Explore Services
          </Link>
        </div>
      </div>
    </section>
  );
}
